/* JOOLHOUSE — Theme JavaScript */

(function () {

  /* ── LOADER ── */
  window.addEventListener('load', function () {
    setTimeout(function () {
      var l = document.getElementById('jh-loader');
      if (l) l.classList.add('gone');
    }, 900);
  });

  /* ── SLIDESHOW ── */
  var slides = document.querySelectorAll('.slide');
  var dots   = document.querySelectorAll('.sd-dot');
  var cur = 0, timer;

  function goSlide(n) {
    if (!slides.length) return;
    slides[cur].classList.remove('active');
    if (dots[cur]) dots[cur].classList.remove('active');
    cur = (n + slides.length) % slides.length;
    slides[cur].classList.add('active');
    if (dots[cur]) dots[cur].classList.add('active');
    var sc = document.getElementById('sc-cur');
    if (sc) sc.textContent = String(cur + 1).padStart(2, '0');
    var nm = document.getElementById('hns-name');
    var sb = document.getElementById('hns-sub');
    var sl = slides[cur];
    if (nm && sl) {
      nm.style.opacity = '0';
      setTimeout(function () {
        nm.textContent = sl.getAttribute('data-name') || '';
        nm.style.opacity = '1';
      }, 250);
    }
    if (sb && sl) sb.textContent = sl.getAttribute('data-sub') || '';
  }

  window.goSlide = goSlide;

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(function () { goSlide(cur + 1); }, 5000);
  }

  if (slides.length) {
    startTimer();
    var hero = document.querySelector('.hero-full');
    if (hero) {
      hero.addEventListener('mouseenter', function () { clearInterval(timer); });
      hero.addEventListener('mouseleave', startTimer);
    }
  }

  /* ── NAV: transparent → solid on scroll ── */
  var nav = document.querySelector('.jh-nav');
  var lastScroll = 0;
  window.addEventListener('scroll', function () {
    var sy = window.scrollY;
    if (nav) {
      nav.classList.toggle('scrolled', sy > 60);
      if (sy > lastScroll + 8 && sy > 180) {
        nav.classList.add('hidden');
      } else if (sy < lastScroll - 8) {
        nav.classList.remove('hidden');
      }
    }
    lastScroll = sy;
    /* parallax on split images */
    document.querySelectorAll('.split-img img').forEach(function (img) {
      var rect = img.closest('.split-img').getBoundingClientRect();
      var off  = (rect.top + rect.height / 2 - window.innerHeight / 2) * 0.06;
      img.style.transform = 'translateY(' + off + 'px)';
    });
  });

  /* ── SCROLL REVEAL ── */
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('in');
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

  function initReveal() {
    document.querySelectorAll('.rev,.rev-l,.rev-r,.rev-s').forEach(function (el) {
      obs.observe(el);
    });
  }
  initReveal();

  /* ── MOBILE MENU ── */
  window.jhToggle = function () {
    var btn    = document.querySelector('.jh-mob-btn');
    var drawer = document.querySelector('.jh-drawer');
    if (btn)    btn.classList.toggle('open');
    if (drawer) drawer.classList.toggle('open');
  };
  window.jhClose = function () {
    var btn    = document.querySelector('.jh-mob-btn');
    var drawer = document.querySelector('.jh-drawer');
    if (btn)    btn.classList.remove('open');
    if (drawer) drawer.classList.remove('open');
  };
  document.addEventListener('click', function (e) {
    var drawer = document.querySelector('.jh-drawer');
    var btn    = document.querySelector('.jh-mob-btn');
    if (drawer && drawer.classList.contains('open') &&
        btn && !drawer.contains(e.target) && !btn.contains(e.target)) {
      jhClose();
    }
  });

  /* ── SHOP FILTER ── */
  window.jhFilter = function (btn, type) {
    document.querySelectorAll('.sf').forEach(function (b) { b.classList.remove('on'); });
    if (btn) btn.classList.add('on');
    document.querySelectorAll('.pc[data-type]').forEach(function (c) {
      var t = c.getAttribute('data-type');
      var show = type === 'all' || t === type;
      c.style.display = show ? '' : 'none';
      if (show) {
        c.style.opacity = '0'; c.style.transform = 'translateY(18px)';
        setTimeout(function () {
          c.style.transition = 'opacity .4s, transform .4s';
          c.style.opacity = '1'; c.style.transform = '';
        }, 60);
      }
    });
  };

  /* ── PRODUCT IMAGE SWITCHER ── */
  window.jhSwapImg = function (src, thumb) {
    var main = document.querySelector('.pd-gallery-main');
    if (!main) return;
    main.style.opacity = '0';
    setTimeout(function () { main.src = src; main.style.opacity = '1'; }, 220);
    document.querySelectorAll('.pd-thumb').forEach(function (t) { t.classList.remove('active'); });
    if (thumb) thumb.classList.add('active');
  };

  /* ── RESPONSIVE ── */
  function handleResize() {
    var mob = window.innerWidth <= 600;
    var mn  = document.querySelector('.jh-mob-nav');
    if (mn) mn.style.display = mob ? 'flex' : 'none';
  }
  window.addEventListener('resize', handleResize);
  handleResize();

})();
/* ── PRODUCT CARD VARIANT SWATCHER ── */
function jhSwatchIn(btn) {
  var card = btn.closest('.pc');
  if (!card) return;
  var imgSrc = btn.getAttribute('data-img');
  var vid = btn.getAttribute('data-vid');
  var def = card.querySelector('.pc-img-default');
  var vars = card.querySelectorAll('.pc-img-var');
  vars.forEach(function(v) { v.classList.remove('visible'); });
  var matched = card.querySelector('.pc-img-var[data-vid="' + vid + '"]');
  if (matched) {
    if (def) def.style.opacity = '0';
    matched.classList.add('visible');
  } else {
    if (def && imgSrc) {
      if (!def.getAttribute('data-orig')) def.setAttribute('data-orig', def.src);
      def.src = imgSrc;
    }
  }
  card.querySelectorAll('.pc-sw').forEach(function(s) { s.classList.remove('on'); });
  btn.classList.add('on');
}

function jhSwatchClick(productUrl, variantId) {
  window.location.href = productUrl + '?variant=' + variantId;
}

document.addEventListener('mouseleave', function(e) {
  var card = e.target.closest && e.target.closest('.pc');
  if (!card) return;
  var def = card.querySelector('.pc-img-default');
  card.querySelectorAll('.pc-img-var').forEach(function(v) { v.classList.remove('visible'); });
  if (def) {
    def.style.opacity = '';
    var orig = def.getAttribute('data-orig');
    if (orig) def.src = orig;
  }
}, true);